import { type PropsWithChildren } from 'react';

import { ColorRuleContext } from '../../core/context/ColorRuleContext.js';
import { HoneycombLegendConfigContext } from '../context/honeycomb-legend-config.context.js';
import { HoneycombToolbarConfigContext } from '../context/honeycomb-toolbar-config.context.js';
import { HoneycombSlotsConfig } from '../types/honeycomb-internal.js';

export const HoneycombConfigurationProvider = ({
  children,
  config,
}: PropsWithChildren<{ config: HoneycombSlotsConfig }>) => {
  const { legend, toolbar } = config;

  return (
    <HoneycombLegendConfigContext.Provider value={legend}>
      <HoneycombToolbarConfigContext.Provider value={toolbar}>
        <ColorRuleContext.Provider value={config.colorRules}>
          {children}
        </ColorRuleContext.Provider>
      </HoneycombToolbarConfigContext.Provider>
    </HoneycombLegendConfigContext.Provider>
  );
};
